export const SessionInfo: any = {
  ElementaryTimeGoal: 60,
  SecondaryTimeGoal: 60,
}
